<script>
import {mapState} from 'vuex';

export default{
  name: "EditTemplate",
  computed: {
    ...mapState('whatsapp', ['currentCategory', 'selectedMessageType']),
  },
  data(){
    return{
      templateName: "",
      selectedCategory: "AUTHENTICATION",
      selectedFormat: "POSITIONAL",
      templateBody: "",
      selectedHeaderType: 'none',
      selectedLanguage: { name: "English", code: "en" },
      catalogueButtonText: 'View catalogue',
      ctaText: 'View Flow',
      selectedCatalogueFormat: 'catalogue',
      autoFillText: 'Auto-fill',
      copyCodeText: 'Copy code',
      selectedCodeDelivery: 'zero-tap',
      headerTypes: [
        { name: 'None', value: 'none' },
        { name: 'Text', value: 'text' },
        { name: 'Image', value: 'image' },
        { name: 'Video', value: 'video' },
        { name: 'Document', value: 'document' },
        { name: 'Location', value: 'location' }
      ],
      languages: [
        { name: "Afrikaans", code: "af" },
        { name: "Albanian", code: "sq" },
        { name: "Arabic", code: "ar" },
        { name: "Arabic (EGY)", code: "ar_EG" },
        { name: "Arabic (UAE)", code: "ar_AE" },
        { name: "Arabic (LBN)", code: "ar_LB" },
        { name: "Arabic (MAR)", code: "ar_MA" },
        { name: "Arabic (QAT)", code: "ar_QA" },
        { name: "Azerbaijani", code: "az" },
        { name: "Belarusian", code: "be_BY" },
        { name: "Bengali", code: "bn" },
        { name: "Bengali (IND)", code: "bn_IN" },
        { name: "Bulgarian", code: "bg" },
        { name: "Catalan", code: "ca" },
        { name: "Chinese (CHN)", code: "zh_CN" },
        { name: "Chinese (HKG)", code: "zh_HK" },
        { name: "Chinese (TAI)", code: "zh_TW" },
        { name: "Croatian", code: "hr" },
        { name: "Czech", code: "cs" },
        { name: "Danish", code: "da" },
        { name: "Dari", code: "prs_AF" },
        { name: "Dutch", code: "nl" },
        { name: "Dutch (BEL)", code: "nl_BE" },
        { name: "English", code: "en" },
        { name: "English (UK)", code: "en_GB" },
        { name: "English (US)", code: "en_US" },
        { name: "English (UAE)", code: "en_AE" },
        { name: "English (AUS)", code: "en_AU" },
        { name: "English (CAN)", code: "en_CA" },
        { name: "English (GHA)", code: "en_GH" },
        { name: "English (IRL)", code: "en_IE" },
        { name: "English (IND)", code: "en_IN" },
        { name: "English (JAM)", code: "en_JM" },
        { name: "English (MYS)", code: "en_MY" },
        { name: "English (NZL)", code: "en_NZ" },
        { name: "English (QAT)", code: "en_QA" },
        { name: "English (SGP)", code: "en_SG" },
        { name: "English (UGA)", code: "en_UG" },
        { name: "English (ZAF)", code: "en_ZA" },
        { name: "Estonian", code: "et" },
        { name: "Filipino", code: "fil" },
        { name: "Finnish", code: "fi" },
        { name: "French", code: "fr" },
        { name: "French (BEL)", code: "fr_BE" },
        { name: "French (CAN)", code: "fr_CA" },
        { name: "French (CHE)", code: "fr_CH" },
        { name: "French (CIV)", code: "fr_CI" },
        { name: "French (MAR)", code: "fr_MA" },
        { name: "Georgian", code: "ka" },
        { name: "German", code: "de" },
        { name: "German (AUT)", code: "de_AT" },
        { name: "German (CHE)", code: "de_CH" },
        { name: "Greek", code: "el" },
        { name: "Gujarati", code: "gu" },
        { name: "Hausa", code: "ha" },
        { name: "Hebrew", code: "he" },
        { name: "Hindi", code: "hi" },
        { name: "Hungarian", code: "hu" },
        { name: "Indonesian", code: "id" },
        { name: "Irish", code: "ga" },
        { name: "Italian", code: "it" },
        { name: "Japanese", code: "ja" },
        { name: "Kannada", code: "kn" },
        { name: "Kazakh", code: "kk" },
        { name: "Kinyarwanda", code: "rw_RW" },
        { name: "Korean", code: "ko" },
        { name: "Kyrgyz (Kyrgyzstan)", code: "ky_KG" },
        { name: "Lao", code: "lo" },
        { name: "Latvian", code: "lv" },
        { name: "Lithuanian", code: "lt" },
        { name: "Macedonian", code: "mk" },
        { name: "Malay", code: "ms" },
        { name: "Malayalam", code: "ml" },
        { name: "Marathi", code: "mr" },
        { name: "Norwegian", code: "nb" },
        { name: "Pashto", code: "ps_AF" },
        { name: "Persian", code: "fa" },
        { name: "Polish", code: "pl" },
        { name: "Portuguese (BR)", code: "pt_BR" },
        { name: "Portuguese (POR)", code: "pt_PT" },
        { name: "Punjabi", code: "pa" },
        { name: "Romanian", code: "ro" },
        { name: "Russian", code: "ru" },
        { name: "Serbian", code: "sr" },
        { name: "Sinhala", code: "si_LK" },
        { name: "Slovak", code: "sk" },
        { name: "Slovenian", code: "sl" },
        { name: "Spanish", code: "es" },
        { name: "Spanish (ARG)", code: "es_AR" },
        { name: "Spanish (CHL)", code: "es_CL" },
        { name: "Spanish (COL)", code: "es_CO" },
        { name: "Spanish (CRI)", code: "es_CR" },
        { name: "Spanish (DOM)", code: "es_DO" },
        { name: "Spanish (ECU)", code: "es_EC" },
        { name: "Spanish (HND)", code: "es_HN" },
        { name: "Spanish (MEX)", code: "es_MX" },
        { name: "Spanish (PAN)", code: "es_PA" },
        { name: "Spanish (PER)", code: "es_PE" },
        { name: "Spanish (SPA)", code: "es_ES" },
        { name: "Spanish (URY)", code: "es_UY" },
        { name: "Swahili", code: "sw" },
        { name: "Swedish", code: "sv" },
        { name: "Tamil", code: "ta" },
        { name: "Telugu", code: "te" },
        { name: "Thai", code: "th" },
        { name: "Turkish", code: "tr" },
        { name: "Ukrainian", code: "uk" },
        { name: "Urdu", code: "ur" },
        { name: "Uzbek", code: "uz" },
        { name: "Vietnamese", code: "vi" },
        { name: "Zulu", code: "zu" }
      ],
      cursorPos: 0,
    }
  },
  methods: {
    onTextInput() {
      this.$nextTick(() => {
        this.normalizeVariables();
      });
    },

    saveCursorPosition() {
      const textarea = this.$refs.textarea;
      this.cursorPos = textarea.selectionStart;
    },

    normalizeVariables() {
      const pattern = /{{\d+}}/g;
      const matches = [...this.templateBody.matchAll(pattern)];

      // Build mapping from original to sequential replacements
      const orderedMatches = [];
      const seen = new Set();

      matches.forEach(match => {
        const val = match[0];
        if (!seen.has(val)) {
          seen.add(val);
          orderedMatches.push(val);
        }
      });

      const map = {};
      orderedMatches.forEach((val, i) => {
        map[val] = `{{${i + 1}}}`;
      });

      // Replace using the map
      let updatedText = this.templateBody;
      for (const [original, replacement] of Object.entries(map)) {
        updatedText = updatedText.replace(new RegExp(original, 'g'), replacement);
      }

      this.templateBody = updatedText;
    },

    insertFormat(type) {
      const textarea = this.$refs.textarea;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      if (type === 'variable') {
        this.normalizeVariables();

        const matches = this.templateBody.match(/{{\d+}}/g) || [];
        const usedNumbers = new Set(
          matches.map(v => parseInt(v.replace(/[{}]/g, ''), 10))
        );

        let nextNumber = 1;
        while (usedNumbers.has(nextNumber)) {
          nextNumber++;
        }

        const variableTag = `{{${nextNumber}}}`;
        const before = this.templateBody.slice(0, start);
        const after = this.templateBody.slice(end);

        this.templateBody = `${before}${variableTag}${after}`;

        this.$nextTick(() => {
          textarea.focus();
          const cursor = start + variableTag.length;
          textarea.setSelectionRange(cursor, cursor);
        });
        return;
      }

      const markers = {
        bold: '*',
        italic: '_',
        strike: '~',
        code: '```'
      };

      const marker = markers[type] || '';

      const selectedText = this.templateBody.slice(start, end);
      const before = this.templateBody.slice(0, start);
      const after = this.templateBody.slice(end);

      this.templateBody = `${before}${marker}${selectedText}${marker}${after}`;

      this.$nextTick(() => {
        textarea.focus();
        type == 'code' ? textarea.setSelectionRange(start + 3, end + 3) : textarea.setSelectionRange(start + 1, end + 1);
      });
    },
  }
}
</script>

<template>
<div class="flex gap-4 flex-wrap mb-12">
  <section class="flex flex-col gap-4">
    <div class="flex gap-4 rounded-md bg-white p-4 items-center">
      <span class="p-4 rounded-md bg-woot-500">
        <fluent-icon icon="megaphone" size="36" />
      </span>
      <span>
        <h1>{{ templateName.length != 0 ? templateName : 'your_template_name' }} • {{ selectedLanguage.name }}</h1>
        <p>{{ currentCategory.charAt(0).toUpperCase() + currentCategory.slice(1) }} • {{ selectedMessageType }}</p>
      </span>
    </div>

    <div class="flex flex-col gap-4 rounded-md bg-white p-4">
      <h1>Template name and language</h1>
      <div class="flex gap-4">
        <label for="template_name" class="text-sm flex-1">
          Name your template
          <div class="has-[:focus]:border-woot-500 border border-slate-200 rounded-md flex gap-2 px-2 justify-between items-center">
            <input 
              id="template_name" type="text" maxlength="512" 
              v-model="templateName" placeholder="Enter a template name" 
              class="reset-base flex-1 h-[43px] focus:outline-none focus:ring-0" />
            <span class="text-xs text-slate-600 dark:text-white">{{ templateName.length || 0 }} / 512</span>
          </div>
        </label>

        <div class="text-sm flex-1">
          Select language
          <multiselect
            v-model="selectedLanguage"
            :options="languages"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            label="name"
            track-by="code"
            placeholder="Pick a language"
          />
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4 rounded-md bg-white p-4" v-if="this.selectedMessageType == 'Catalogue'"> 
      <h2>Catalogue format</h2>
      <p>Choose the message format that best fits your needs.</p>

      <label class="flex items-center gap-4">
        <input type="radio" v-model="selectedCatalogueFormat" value="catalogue">
        <span>
          <p>Catalogue message</p>  
          <p>Include the entire catalogue to give your users a comprehensive view of all of your products.</p>
        </span>
      </label>
      <label class="flex items-center gap-4">
        <input type="radio" v-model="selectedCatalogueFormat" value="multi-product">
        <span>
          <p>Multi-product message</p>  
          <p>Include up to 30 products from the catalogue. Useful for showcasing new collection or a specific product category. You will need to specify which products via the API.</p>
        </span>
      </label>
    </div>

    <div class="flex flex-col gap-4 rounded-md bg-white p-4" v-if="this.selectedMessageType == 'One-time passcode'"> 
      <h2>Code delivery setup</h2>
      <p>Choose how customers send the code from WhatsApp to your app. Edits to this section won't require review or count towards edit limits. Learn how to send authentication message templates.</p>

      <label class="flex items-center gap-4">
        <input type="radio" v-model="selectedCodeDelivery" value="zero-tap">
        <span>
          <p class="mb-0">Zero-tap auto-fill</p>  
          <p class="text-xs">This is recommended as the easiest option for your customers. Zero-tap will automatically send code without requiring your customer to tap a button. An auto-fill or copy code message will be sent if zero-tap and auto-fill aren't possible.</p>
        </span>
      </label>
      <label class="bg-slate-100 p-2 rounded-md">
        <input type="checkbox" />
        By selecting zero-tap, I understand that PTL Group's use of zero-tap authentication is subject to the WhatsApp Business Terms of Service . It's PTL Group 's responsibility to ensure that its customers expect that the code will be automatically filled in on their behalf when they choose to receive the zero-tap code through WhatsApp.
        Learn more and review best practices.

        <p class="rounded-md bg-red-100 p-2">
          This box must be ticked to submit this template.
        </p>
      </label>
      <label class="flex items-center gap-4">
        <input type="radio" v-model="selectedCodeDelivery" value="one-tap">
        <span>
          <p class="mb-0">One-tap auto-fill</p>  
          <p class="text-xs">The code sends to your app when customers tap the button. A copy code message will be sent if auto-fill isn't possible.</p>
        </span>
      </label>
      <label class="flex items-center gap-4">
        <input type="radio" v-model="selectedCodeDelivery" value="copyCode">
        <span>
          <p class="mb-0">Copy code</p>  
          <p class="text-xs">Basic authentication with quick setup. Your customers copy and paste the code into your app.</p>
        </span>
      </label>
    </div>

    <div class="flex flex-col rounded-md bg-white p-4" v-if="this.selectedMessageType == 'One-time passcode'"> 
      <h2>App Setup</h2>
      <p>You can select up to 5 apps.</p>

      <div class="flex gap-2">
        <label>
          Package name
          <input type="text">
        </label>
        <label>
          App signature hash
          <input type="text">
        </label>
      </div>

      <div>
        <woot-button variant="clear">Make another app</woot-button>
      </div>
    </div>

    <div class="flex flex-col rounded-md bg-white p-4" v-if="this.selectedMessageType == 'One-time passcode'"> 
      <h2>Content</h2>
      <p>Content for authentication message templates can't be edited. You can add additional content from the options below.</p>

      <div class="flex flex-col gap-2">
        <label>
          <input type="checkbox">
          Add security recommendation
        </label>
        <label>
          <input type="checkbox">
          Add expiry time for the code. After the code has expired, the auto-fill button will be disabled.
        </label>
      </div>
    </div>

    <div class="flex flex-col rounded-md bg-white p-4" v-if="this.selectedMessageType == 'Catalogue'">
      <h2>Catalogue setup</h2>
      <p>Connecting a catalogue will allow customers to view, message and send carts containing your products and services via WhatsApp. Learn more</p>
      <br />
      <p class="py-1 px-2 bg-slate-200 rounded-md">Please note that you cannot add media to this template. Instead, you can link your catalogue to showcase your products.</p>
      <span>
        <woot-button>Connect catalogue</woot-button>
      </span>
    </div>

    <div class="flex flex-col gap-4 rounded-md bg-white p-4" v-if="selectedMessageType != 'One-time passcode'">
      <h1>Content</h1>
      <p>Fill in the header, body and footer sections of your template.</p>
      <label>
        <span class="flex gap-2">
          <p>Variable</p> 
          <fluent-icon icon="info" size="12" v-tooltip.bottom-end="{
            content: `
              <strong>Type of variable</strong><br>
              Variables are placeholders for dynamic data in your template.<br><br>
              <strong>Examples:</strong><br>
              • Name: <code>{{order_id}}</code><br>
              • Number: <code>{{1}}</code>
            `,
            html: true,
            theme: 'tooltip-custom'
          }" />
        </span>
        <select v-model="selectedFormat">
          <option value="POSITIONAL">Number</option>
          <option value="NAMED">Name</option>
        </select>
      </label>

      <label>
        Header
        <select v-model="selectedHeaderType">
          <option v-for="(type, index) in headerTypes" :key="index" :value="type.value">{{ type.name }}</option>
        </select>
        <input type="text" v-if="selectedHeaderType == 'text'" :placeholder="`Enter text in ${selectedLanguage.name}`"/>
      </label>

      <label>
        Body
        <textarea 
          ref="textarea"
          v-model="templateBody"
          rows="4"
          class="mb-0"
          @click="saveCursorPosition"
          @keyup="saveCursorPosition"
          @input="onTextInput"
        />
        <span class="flex justify-end gap-4">
          <woot-button variant="clear" size="small" color-scheme="secondary" @click="insertFormat('bold')">B</woot-button>
          <woot-button variant="clear" size="small" color-scheme="secondary" @click="insertFormat('italic')">I</woot-button>
          <woot-button variant="clear" size="small" color-scheme="secondary" @click="insertFormat('strike')">S</woot-button>
          <woot-button variant="clear" size="small" icon="code" color-scheme="secondary" @click="insertFormat('code')"></woot-button>
          <woot-button variant="clear" size="small" icon="add" color-scheme="secondary" @click="insertFormat('variable')">add variable</woot-button>
          <fluent-icon icon="info" />
        </span>
      </label>
      

      <label>
        Footer
        <input type="text" placeholder="Enter text"/>
      </label>
    </div>

    <div class="flex flex-col gap-4 rounded-md bg-white p-4">
      <h1>Buttons <span v-if="selectedMessageType == 'Custom'">. optional</span></h1>

      <p v-if="selectedMessageType == 'Custom'" class="text-xs text-slate-600">Create buttons that let customers respond to your message or take action. You can add up to ten buttons. If you add more than three buttons, they will appear in a list.</p>
      <p v-if="selectedMessageType == 'One-time passcode'" class="text-xs text-slate-600">You can customise the button text for both auto-fill and copy code. Even when zero-tap is turned on, buttons are still needed for the backup code delivery method.</p>
      <p v-else class="py-1 px-2 bg-slate-200 rounded-md">Only one button is supported for this type of template. The button text is not editable.</p>
      
      <div class="flex justify-end w-full" v-if="selectedMessageType == 'Custom' || selectedMessageType == 'Flows'">
        <woot-button icon="add" variant="clear">Add Buttons</woot-button>
      </div>

      <div v-if="selectedMessageType == 'Flows'" class="flex flex-col gap-4 rounded-md bg-white p-4">
        <p>Call to action . optional</p>
        <div class="p-2 bg-slate-200 rounded-md">
          <div class="px-4 py-2 rounded-md bg-white">
            <div class="flex gap-2">
              <label>
                Type of action
                <select>
                  <option value="call" selected>Call Phone Number</option>
                  <option value="copy_code">Copy Offer Code</option>
                  <option value="visit_website">Visit Website</option>
                  <option value="complete_flow">Complete Flow</option>
                </select>
              </label>

              <label>
                Button icon
                <select>
                  <option value="default">Default</option>
                  <option value="document">Document</option>
                  <option value="promotion">Promotion</option>
                  <option value="review">Review</option>
                </select>
              </label>

              <label>
                Button text
                <input type="text" v-model="ctaText" />
              </label>
            </div>

            <div class="flex gap-2">
              <woot-button variant="clear">Create New</woot-button>
              <woot-button variant="clear">Use Existing</woot-button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="selectedMessageType == 'Catalogue'" class="p-2 bg-slate-200 rounded-md">
        <div class="px-4 py-2 rounded-md bg-white">
          <p>Button Text</p>
          <input type="text" v-model="catalogueButtonText" disabled/>
        </div>
      </div>

      <div v-if="selectedMessageType == 'One-time passcode'" class="flex gap-4">
        <label>
          Auto-fill
          <input type="text" v-model="autoFillText" />
        </label>
        <label>
          Copy code
          <input type="text" v-model="copyCodeText" />
        </label>
      </div>
    </div>

    <div class="flex flex-col gap-4 rounded-md bg-white p-4" v-if="this.currentCategory != 'marketing'">
      <h1>Message validity period</h1>
      <p class="text-xs text-slate-600">You can set a custom validity period that your utility message must be delivered by before it expires. If a message has not been delivered within this time frame, you will not be charged and your customer will not see the message.</p>
        <p class="flex flex-col">
          <strong>Set custom validity period for your message</strong>
          <span class="text-slate-600 text-sm">If you don't set a custom validity period, the standard 10 minutes WhatsApp message validity period will be applied.</span>
        </p>
    </div>
  </section>

  <!-- <section>
    <h1>Template Preview</h1>
  </section> -->
</div>
</template>